import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

class ImageExpand extends React.Component {
  state = {
    modal: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    if (this.props.imageUrl) {
      return (
        <div className="image-wrapper">
          <img alt="question" src={this.props.imageUrl} />
          <Button color="link" className="expand-image" onClick={this.toggle}>
            <i className="icon-zoom" />
          </Button>
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            modalClassName="expanded-image-modal"
          >
            <ModalBody>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={this.toggle}
              >
                <span aria-hidden="true">×</span>
              </button>
              <img
                width="100%"
                alt="Question bigger"
                src={this.props.imageUrl}
              />
            </ModalBody>
          </Modal>
        </div>
      );
    }
    return null;
  }
}

export default ImageExpand;
